var TextSVGTiles = (function () {
  

  var Utility = window.Utility || {};

  Utility.log('TextSVGTiles.js loaded');

  function numDivs() {
    var myDivs = $('.svg-tiles .acr-tools');

    var myDivsLast = $('.svg-tiles .acr-tools:last-child');

    var myDivsNth3 = $('.svg-tiles .acr-tools:nth-child(3n)');

    var countDivs = $(myDivs).length;

    if (countDivs === 2) {
      myDivs.addClass('col-xs-12 col-xs-push-6');

    } else if (countDivs === 3) {
      myDivs.addClass('col-xs-12');

    } else if (countDivs === 4) {
      myDivs.addClass('col-xs-12 col-xs-push-6');

      myDivsNth3.css('clear', 'both');

    } else if (countDivs === 5) {
      myDivs.addClass('col-xs-12');

      $(myDivsLast).prev('.acr-tools')
        .andSelf()
        .addClass('col-xs-push-6');

    } else if (countDivs === 6) {
      myDivs.addClass('col-xs-12');

    }
  }

  function init() {
    numDivs();
  }

  return {
    init: init,
  };
}());
